import { render, staticRenderFns } from "./header.edit.delete.buttons.vue?vue&type=template&id=4e09e03f&"
import script from "./header.edit.delete.buttons.vue?vue&type=script&lang=ts&"
export * from "./header.edit.delete.buttons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports